/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_Invalid_EmailInputs */



/**
* | output |
* | --- |
* | "Please enter a valid email address." |
*
* @param {Login_Error_Invalid_EmailInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_error_invalid_email = /** @type {((inputs?: Login_Error_Invalid_EmailInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_Invalid_EmailInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez entrer une adresse email valide.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte geben Sie eine gültige E-Mail-Adresse ein.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Si prega di inserire un indirizzo email valido.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, введите действительный адрес электронной почты.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Por favor, introduce una dirección de correo electrónico válida.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请输入有效的电子邮件地址。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("有効なメールアドレスを入力してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया एक मान्य ईमेल पता प्रविष्ट करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por favor, insira um endereço de e-mail válido.")
	return /** @type {LocalizedString} */ ("Please enter a valid email address.")
});